import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function validateRoutePerms(perms) {
  try {
    const res = await tryCache('validateRoutePerms' + '-' + perms, () =>
      apiClient.post('/validateRoutePerms', {
        perms,
      }),
    );
    return res;
  } catch (error) {
    console.error('validateRoutePerms failed.', error);
  }
}

export async function getUserPerms() {
  try {
    const res = await tryCache('getUserPerms', () => apiClient.get('/getfusionUserPerms'));

    return res;
  } catch (error) {
    console.error('getUserPerms failed.', error);
  }
}

export async function getAccessLevel() {
  try {
    const res = await tryCache('checkAuthLevel', () => apiClient.post('/checkAuthLevel'));
    return res;
  } catch (error) {
    console.error('getAccessLevel failed.', error);
  }
}

export async function getGlobalWidgetPermList() {
  try {
    const res = await tryCache('getGlobalWidgetPermList', () =>
      apiClient.get('/getGlobalWidgetPermList'),
    );
    return res;
  } catch (error) {
    console.error('getGlobalWidgetPermList failed.', error);
  }
}
